import type { SVGProps } from "react";

export function OutdoorPoolIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.43311 5.63333V4.8C6.44185 4.38443 6.61366 3.98897 6.91145 3.69898C7.20924 3.40898 7.60912 3.24772 8.02477 3.25C8.44691 3.25 8.85175 3.41769 9.15025 3.71619C9.44875 4.01468 9.61644 4.41953 9.61644 4.84167V12.8333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M12.8335 3.25C13.0428 3.24889 13.2503 3.28931 13.4439 3.36891C13.6375 3.44851 13.8134 3.5657 13.9614 3.71372C14.1095 3.86175 14.2267 4.03765 14.3063 4.23126C14.3859 4.42487 14.4263 4.63234 14.4252 4.84167V12.8333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path d="M9.6167 10.4083H14.3834" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
      <path d="M9.6167 7.225H14.3834" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
      <path
        d="M14.3833 6.43333H20.75V20.75H3.25V6.43333H8.025"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M5.6333 14.3833C7.09163 14.3833 7.09163 15.2167 8.54997 15.2167C10.0083 15.2167 10.0083 14.3833 11.4666 14.3833C12.925 14.3833 12.925 15.2167 14.3833 15.2167"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.4082 17.5667C11.8665 17.5667 11.8665 18.4 13.3249 18.4C14.7832 18.4 14.7832 17.5667 16.2415 17.5667C17.6999 17.5667 17.6999 18.4 19.1582 18.4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
